import {
  AutomationActionMicrosoftAddToGroupDenormalized,
  IAutomationActionTemplateMicrosoftAddToGroup
} from '@dadohr/shared/domainTypes/experience';
import { useUnsafeTranslation } from '../../../../../../../i18next';
import { joinWithCommaAndAnd } from '../../../../../../../services/enumerate';
import { LightMdToJsx } from '../../../../../../../services/formatter';
import { MinimalTaskBuilderContext } from '../../../TaskBuilder/types';
import { actionActorToString } from '../../shared';
import { ActionDefinition } from '../../types';
import {
  ActionSummaryBody,
  ActionSummaryContainer,
  ActionSummaryHeading
} from '../shared';

export const ActionSummaryMicrosoftGroupAdd = ({
  a,
  expTpl,
  def
}: {
  a:
    | IAutomationActionTemplateMicrosoftAddToGroup
    | AutomationActionMicrosoftAddToGroupDenormalized;
  expTpl: MinimalTaskBuilderContext;
  def: ActionDefinition;
}) => {
  const { t } = useUnsafeTranslation();

  return (
    <ActionSummaryContainer>
      <ActionSummaryHeading def={def} />
      <ActionSummaryBody>
        <LightMdToJsx>
          {t('Add **{{ participants }}** to {{ groupName }}.', {
            participants:
              joinWithCommaAndAnd(
                a.pplToAdd.map((o) =>
                  actionActorToString(o, expTpl.supportingActors, t)
                ),
                t
              ) || 'someone',
            groupName: a.group?.name
              ? `the group/team **${a.group.name}**`
              : '**a group/team**'
          })}
        </LightMdToJsx>
      </ActionSummaryBody>
    </ActionSummaryContainer>
  );
};
